import React from 'react';

import { Flex } from 'common/flex';
import { Subtitle } from 'common/subtitle';

interface Props {
  label: string;
  direction?: 'column' | 'row';
}

export const TextContainer = ({
  label,
  children,
  direction = 'column',
}: React.PropsWithChildren<Props>) => {
  return (
    <Flex
      flexDirection={direction}
      gap={direction === 'column' ? '0px' : '7px'}
    >
      <Subtitle text={direction === 'column' ? label : `${label}:`} />
      <p>{children}</p>
    </Flex>
  );
};
